import { Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-uig-product-manufacturer',
    templateUrl: './uig-product-manufacturer.component.html',
    styleUrls: ['./uig-product-manufacturer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductManufacturerComponent implements OnInit {

  product$: Observable<Product> = this.currentProductService.getProduct();

  constructor(private currentProductService: CurrentProductService) { }

  ngOnInit(): void {
  }

}
